import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const GetAdvertisersDisplays = {
  name: 'getAdvertisersDisplays',
  state: {
    data: [],
    allRecords: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Display Owner',
      'Display Name',
      'Address',
      'Industry',
      // 'Region',
      'Visibility',
      'Visibility Status',
      'Favorites',
      'Layout',
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      // eslint-disable-next-line array-callback-return
      const advertisersDisplays = payload.data.map((item) => ({
        DisplayOwner: item.Organization.name,
        name: item.name,
        Address: item.location.address,
        Industry: item?.Organization?.industry ? item?.Organization?.industry : '-',
        // Region: item.region,
        Visibility: item?.visibility,
        // VisibilityStatus:
        //   item.visibility === 'Public' || item.visibility === 'Hidden'
        //     ? 'Available'
        //     : capitalizeFirstLetter(item.visibilityStatus),
        // // VisibilityStatus: item?.visibility === 'Private' ?  capitalizeFirstLetter('available') : capitalizeFirstLetter(item.visibilityStatus),
        VisibilityStatus: capitalizeFirstLetter(item.visibilityStatus),
        active: item.active,
        isFavourite: item?.advertiser_displays_mapper[0]?.isFavourite ? item?.advertiser_displays_mapper[0]?.isFavourite : false,
        display_id: item?.advertiser_displays_mapper[0]?.display_id ? item?.advertiser_displays_mapper[0]?.display_id : item.id,
        org_id: item?.advertiser_displays_mapper[0]?.org_id,
        layout: item?.rateSchedule?.zonesPreviewSnapshot || null,
      }));

      const allRecordDisplays = payload.displays.map((item) => ({
        DisplayOwner: item.Organization.name,
        name: item.name,
        Address: item.location.address,
        Industry: item?.Organization?.industry ? item?.Organization?.industry : '-',
        // Region: item.region,
        Visibility: item.visibility,
        VisibilityStatus: capitalizeFirstLetter(item.visibilityStatus),
        active: item.active,
        isFavourite: item?.advertiser_displays_mapper[0]?.isFavourite ? item?.advertiser_displays_mapper[0]?.isFavourite : false,
        display_id: item?.advertiser_displays_mapper[0]?.display_id ? item?.advertiser_displays_mapper[0]?.display_id : item.id,
        org_id: item?.advertiser_displays_mapper[0]?.org_id,
        layout: item?.rateSchedule?.zonesPreviewSnapshot || null,
      }));
      return {
        ...state,
        data: advertisersDisplays,
        allRecords: allRecordDisplays,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size, search, selectFilter, sorted_by, sort, isFavourite = false, }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/displays/adv-displays/${userInfo.org_id}?page=${page}&size=${size}`;
        url += `&isFavourite=${isFavourite ? 'true' : 'false'}`;
        if (search) {
          if (
            search.toLowerCase() === 'inactive' ||
            search.toLowerCase() === 'active'
          ) {
            url =
              url + `&active="${search.toLowerCase() === 'inactive' ? 0 : 1}"`;
          } else {
            url = url + `&search=${search}`;
          }
        }
        if (selectFilter?.visibility) {
          url += `&visibility=${selectFilter.visibility}`;
        }
        if (selectFilter?.industry?.length) {
          selectFilter.industry.forEach(ind => {
            url += `&industry[]=${encodeURIComponent(ind)}`;
          });
        }
        if(sorted_by && sort) {
          url += `&sorted_by=${sorted_by}&sort=${sort}`;
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          displays: response.data.data.allDisplays,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAdvertisersDisplays;
